import { Component, OnInit } from '@angular/core';
import { SpecializationPickerService } from 'src/app/jobseeker/shared/services/specialization-picker.service';

@Component({
    selector: 'app-test-dashboard',
    templateUrl: './test-dashboard.component.html',
    styleUrls: ['./test-dashboard.component.scss'],
    standalone: false
})
export class TestDashboardComponent implements OnInit {

  constructor(private specializationPicker: SpecializationPickerService) { }

  public testCategoryPicker() {
    this.specializationPicker.pickCategory(categoryIds => {
      alert(categoryIds);
    },
      [365, 676, 77, 76, 86, 87, 75]
    );
  }

  ngOnInit(): void {
  }

}
